import { areDatesOneDayApart } from '../global/utils';

export class HabitDates {
	constructor(
		parentID=-1,
		dates= [],
	) {
		this.parentID = parentID;
		this.dates = dates;
		this.datesLength = this.dates.length;
		this.noneStreakingDates = new Set();

		this.calculateNoStreaks();
	}

	getDates() {
		return this.dates;
	}

	setDates(newDates=[]) {
		this.dates = newDates;

		this.calculateNoStreaks();
	}

	calculateNoStreaks() {
		const datesLength = this.dates.length;

		if ( datesLength === 0 || datesLength === 1 ) {
            return false;
        }

		for ( let i = 0; i < this.dates.length -1; i++ ) {
			const curDate = this.dates[i];
			const nextDate = this.dates[i+1];
			const oneDayApart = areDatesOneDayApart(curDate, nextDate);

			if ( !oneDayApart ) {
				this.noneStreakingDates.add(nextDate);
			}
		}
	}

	dateInAStreak(date) {
		return !this.noneStreakingDates.has(date);
	}
}